import { Component, Input, OnInit } from '@angular/core';

import { Lancamento } from '../../../../pages/financeiro/conciliacao/models/lancamento';

@Component({
  selector: 'app-correspondencia-table',
  standalone: false,
  templateUrl: './correspondencia-table.component.html',
  styleUrl: './correspondencia-table.component.scss'
})
export class CorrespondenciaTableComponent implements OnInit {
  @Input({ required: true })
  lancamentos: Lancamento[];
  @Input({ required: true })
  nome: string;
  
  qtdLancamentos: number;
  valorLancamentos: number;

  ngOnInit(): void {
    this.qtdLancamentos = this.lancamentos.length;
    this.valorLancamentos = this.lancamentos.reduce((acc, l) => acc + l.valor, 0);
  }
}
